import { useEffect, useState } from "react"
import { usePoll, usePage, router } from '@inertiajs/react'

import { organizationsSubscription } from "@/api"

import { AlertCircle } from "lucide-react"
import Markdown from "react-markdown"
import Layout from "@/pages/layouts/application"
import { Skeleton } from "@/components/ui/skeleton"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "@/components/ui/dialog"
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@/components/ui/alert"
import { PageHeader } from "@/components/core/page_header"

export default function Show({ settings }) {
  const { start, stop } = usePoll(2000, {}, { autoStart: false })
  const [showPaymentModal, setShowPaymentModal] = useState(false)
  const { organization } = usePage().props.auth

  useEffect(() => {
    start()
  }, [])

  useEffect(() => {
    if (settings?.strategy_md) {
      stop()

      // Only show payment modal if organization is not subscribed
      if (!organization.subscribed) {
        const timer = setTimeout(() => {
          setShowPaymentModal(true)
        }, 2000)

        return () => clearTimeout(timer)
      }
    }
  }, [settings?.strategy_md, organization.subscribed])

  const onSubscribe = () => {
    router.post(organizationsSubscription.create.path({ org_nano_id: organization.nano_id }))
  }

  return (
    <Layout>
      <PageHeader
        title="Your content strategy"
        description="This is a rough version based on the details you provided. Our human editorial team goes through each of these and refines it based on your goals!">
        {!organization.subscribed && (
          <Button onClick={onSubscribe} variant="default">
            Upgrade
          </Button>
        )}
      </PageHeader>

      {!organization.subscribed && organization.free_posts_remaining <= 0 && (
        <Alert className="bg-secondary">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Upgrade to unlock full access</AlertTitle>
          <AlertDescription>
            We have humans in the loop and we're bootstrapped. You know how it is :)
          </AlertDescription>
        </Alert>
      )}

      {settings?.strategy_md ? (
        <Markdown className="prose prose-invert">
          {settings.strategy_md}
        </Markdown>
      ) : (
        <div className="space-y-2 flex-grow">
          <Skeleton className="h-4 w-[250px]" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-[200px]" />
          <Skeleton className="h-4 w-[250px]" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-[250px]" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-[200px]" />
          <Skeleton className="h-4 w-[250px]" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-[200px]" />
          <Skeleton className="h-4 w-[250px]" />
          <Skeleton className="h-4 w-full" />
        </div>
      )}

      <Dialog open={showPaymentModal} onOpenChange={setShowPaymentModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Upgrade Your Plan</DialogTitle>
            <DialogDescription>
              Content strategy can only get you so far. Upgrade to our premium plan to unlock your founder/mode potential.
            </DialogDescription>
          </DialogHeader>

          <DialogFooter>
            <Button onClick={() => onSubscribe()}>Go Founder Mode Now</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </Layout>
  )
}
